import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-button-list',
    templateUrl: './button-list.component.html',
    styleUrls: ['./button-list.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class ButtonListComponent implements OnInit {
    @Input() wrapperClasses: ButtonListWrapperClass;
    css: string;
    constructor() {}

    ngOnInit(): void {
        this.css = this.wrapperClasses ? `button-list ${this.wrapperClasses}` : 'button-list';
    }
}

export declare type ButtonListWrapperClass = 'margin-left-auto' | 'tight';
